import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nini_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d && e?.response?.status >= 500) return "Nini is briefly unavailable. Please wait a moment and try again.";
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const LANGUAGE_NAMES = { en: "English", zu: "isiZulu", xh: "isiXhosa", af: "Afrikaans", st: "Sesotho", tn: "Setswana", sw: "Kiswahili", pt: "Português", fr: "Français", yo: "Yorùbá", ha: "Hausa" };
export const CURRENCY_SYMBOLS = { ZAR: "R", NGN: "₦", KES: "KSh", GHS: "GH₵", BWP: "P", ZMW: "ZK", NAD: "N$", MZN: "MT", TZS: "TSh", UGX: "USh", USD: "$", EUR: "€", GBP: "£" };
let activeCurrency = "ZAR";
export const setActiveCurrency = (code) => { activeCurrency = code || "ZAR"; };
export const money = (n, opts = {}) => {
  const o = typeof opts === "string" ? { currency: opts } : opts;
  const v = Number(n || 0);
  const sym = CURRENCY_SYMBOLS[o.currency || activeCurrency] || `${o.currency || activeCurrency} `;
  return `${sym}${v.toLocaleString("en-US", { minimumFractionDigits: o.cents ? 2 : 0, maximumFractionDigits: o.cents ? 2 : 0 })}`;
};

export const fmtDate = (s, withTime = false) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return s;
  const opts = withTime ? { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" } : { day: "numeric", month: "short", year: "numeric" };
  return d.toLocaleDateString("en-ZA", opts);
};

export const relTime = (s) => {
  const d = new Date(s);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(s);
};

export const initials = (name = "") => name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "?";

export const fileUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}?auth=${localStorage.getItem("nini_token") || ""}`;
  return url;
};

export const label = (s = "") => s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const CATEGORIES = [
  ["stokvel", "Stokvel"], ["rotating_savings", "Rotating savings group"], ["savings_club", "Savings club"], ["burial_society", "Burial society"],
  ["family_group", "Family group"], ["investment_club", "Investment club"], ["employee_group", "Employee group"], ["community_org", "Community organisation"], ["other", "Other"],
];
export const ACTIVITIES = [
  ["rotating_contributions", "Rotating contributions", "Members take turns receiving the pooled contributions."],
  ["group_savings", "Group savings", "Save together into a shared group fund."],
  ["goal_based_savings", "Goal-based savings", "Save towards specific targets like a home or a trip."],
  ["special_contributions", "Special contributions", "Once-off collections for funerals, weddings or emergencies."],
  ["emergency_fund", "Emergency fund", "A safety net members can draw on when it matters."],
  ["membership_fees", "Membership fees", "Recurring fees to keep the group running."],
];
export const FREQUENCIES = [["weekly", "Weekly"], ["biweekly", "Biweekly"], ["monthly", "Monthly"], ["quarterly", "Quarterly"], ["custom", "Custom"]];
export const ROLES = ["admin", "chairperson", "treasurer", "secretary", "member", "auditor"];
export const MANAGER_ROLES = ["admin", "chairperson", "treasurer"];
export const VERIFIER_ROLES = ["admin", "treasurer"];
export const APPROVER_ROLES = ["admin", "chairperson", "treasurer", "secretary"];
